import axios from 'axios'
import router from './router'
import store from './store'
import { getToken, getUserInfo } from '@/utils/auth'
import appJS from '@/utils/appJS'
const whiteList = ['/download/product', '/download/register', '/download2/product', '/download2/register'] // 下载页面不在该项目逻辑内
router.beforeEach(async (to, from, next) => {
  // console.log(to, from, next,'222222路由监听')
  // debugger
  await versionCheck()
  if (!to.fullPath.includes('.htm')) localStorage.setItem('currentRouter', to.fullPath)
  appJS.h5JumpPage(to.path) // 通知 app当前跳转页面
  if (getToken() && whiteList.indexOf(to.path) === -1) {
    if (!store.getters.userInfo) {
      if (getUserInfo()) {
        // 本地缓存获取
        store.commit('SET_USER', getUserInfo())
      }
    }
    next()
  } else {
    next()
  }
})
router.onError((error) => {
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    window.location.reload()
  }
})
const versionCheck = async () => {
  if (import.meta.env.MODE === 'development') return
  const response = await axios.get(`/version.json?${Date.now()}`)
  // eslint-disable-next-line no-undef
  if (__APP_VERSION__ !== response.data.version) {
    // eslint-disable-next-line no-undef
    // showDialog({ message: '发现新内容，自动更新中...' }).then(() => {
    //   window.location.reload()
    // });
    window.location.reload()
  }
}
